import { render } from "./DialogTable.vue?vue&type=template&id=23458578&scoped=true"
import script from "./DialogTable.vue?vue&type=script&lang=js"
export * from "./DialogTable.vue?vue&type=script&lang=js"

import "./DialogTable.vue?vue&type=style&index=0&id=23458578&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23458578"]])

export default __exports__